<!-- 顾问支持确认单 -->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <!-- 搜索-->
      <dynamic-search :data="tableFilterList(tableHead)" @search="dataTableSearch">
        <template v-slot:next>
          <el-button v-if="!isAdmin" icon="el-icon-plus" @click="add">新增</el-button>
          <el-button icon="el-icon-upload2" @click="downloadExcel()">导出</el-button>
        </template>
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :config="{ trigger: 'click', mode: 'cell' }"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        border
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
        <template #toolbar="scope">
          <el-button type="text" size="mini" icon="el-icon-view" @click="view(scope.row)"></el-button>
          <el-button type="text" size="mini" v-if="statusEdit(scope.row.billState)" icon="el-icon-edit" @click="edit(scope.row)"></el-button>
          <!-- <el-popover
            :ref="scope.row.id"
            placement="top"
            width="220"
            v-if="scope.row.billState === 2"
          >
            <p>确定退回该顾问支持确认单据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
               <el-button type="primary" size="mini" @click="reject(scope.row)">退回</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-back" slot="reference"></el-button>
          </el-popover> -->
          <!-- <el-popover :ref="scope.row.id" placement="top" width="180" v-if="statusUnAudit(scope.row.billState)">
            <p>确定反审核该收款单据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button type="primary" size="mini" @click="reject(scope.row, 5)">确定</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-circle-close" slot="reference"></el-button>
          </el-popover> -->
          <el-popover :ref="scope.row.id" placement="top" width="180" v-if="statusEdit(scope.row.billState)">
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button :loading="delLoading" type="primary" size="mini" @click="subDelete(scope.row.id)">确定</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>

            <!-- <el-button slot="reference" type="danger" icon="el-icon-delete" size="mini"/> -->
          </el-popover>
        </template>
        <template #icon="row">
          <svg-icon :icon-class="row.icon" />
        </template>
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
import '@/components/EditDataTable';
import DynamicSearch from '@/components/DynamicSearch';
import DataTableMixin from '@/mixins/DataTableMixin';
import '@/components/dynamic-form';
import {downloadExcel } from '@/api/bill/reimburse';
import { tableSataus } from '@/views/bill/mixins/status';
import {add,del} from '@/api/bill/counselor'

export default {
  name: 'Achievement',
  directives: {},
  filters: {},
  mixins: [DataTableMixin, tableSataus],
  components: {
    DynamicSearch
    // eForm,
  },
  data() {
    return {
      delLoading: false,
      supThis: this,
      isAdd: false,
      tableHead: [
        {
          prop: 'code',
          label: '单据编号'
        },
        {
          prop: 'projectCode',
          label: '项目编号',
          query: {
            type: 'input'
          }
        },
        {
          prop: 'supportStartDate',
          label: '支持开始时间'
        },
        {
          prop: 'supportEndDate',
          label: '支持结束时间'
        },
        {
          prop: 'assess',
          label: '效果评估'
        },
        {
          prop: 'remark',
          label: '备注'
        },
         {
          label: '状态',
          prop: 'billState',
          formatter: state => {
            return this.statusName(state);
          }
        }

      ],
      treeData: [],
      treeProps: {
        children: 'children',
        label: 'name'
      },
      formData: {
        isAdd: true,
        id: ''
      }
    };
  },
  computed: {},
  watch: {},
  created() {
    // 列表数据初始化
    this.$nextTick(() => {
      this.dataTableInit();
    });
  },
  methods: {
    // 导出
    downloadExcel() {
      downloadExcel('biz-counselor-affirm/counselorAffirmExcel',this._query,'顾问支持确认单')
    },
    audit(data) {
      // 审核
      // this.updata({ id: data.id, type: 3 });
      const obj = data
      obj.billState  = 3;
      this.updata({counselorAffirm: obj})
      this.$refs[data.id].doClose();
    },
    // 4退回 5 反审核
    reject(data, status = 4) {
     const obj = data
      obj.billState  = status;
      this.updata({counselorAffirm: obj})
      this.$refs[data.id].doClose();
    },
    updata(data) {
      add(data).then(res => {
        if (res.code === 200) {
          this.$notify({
            title: '操作成功',
            type: 'success',
            duration: 2500
          });
          this.dataTableInit();
        }
      });
    },
    view(row) {
      // this.$router.push({ path: 'counselor/form', query: { id: row.id, isAdd: 0 } });
       this.$router.push({name: "counselorForm" ,params: { id: row.id,isEdit: 0 }})
    },
    dataTableBeforeInit() {
      // /counselor 列表
      this._url = '/biz-counselor-affirm';
      const params = { current: this.page, size: this.offset };
      this._params = Object.assign(params, this._query);
      return true;
    },
    handleDeletes(rows) {
      rows.forEach(element => {
        this.subDelete(element.id);
      });
    },
    subDelete(id) {
      this.delLoading = true;
      del({id: id})
        .then(res => {
          this.delLoading = false;
          this.$refs[id].doClose();
          this.dleTableChangePage();
          this.dataTableInit();
          this.$notify({
            title: '删除成功',
            type: 'success',
            duration: 2500
          });
        })
        .catch(err => {
          this.delLoading = false;
          this.$refs[id].doClose();
          console.log(err);
        });
    },
    edit(data) {
      // this.$router.push({ path: 'counselor/form', query: this.formData });
       this.$router.push({name: "counselorForm" ,params: { id: data.id,isEdit: 1 }})
    },
    add() {
      // this.$router.push({ path: 'counselor/form', query: { isAdd: 1 } });
        this.$router.push({name: "counselorForm"})
    }
  }
};
</script>

<style scoped>
.btn {
  border: none;
  padding: 0;
}
</style>
